import React, { useEffect, useState } from 'react'
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
// import { useState } from "react";
import { Nav, Tab } from "react-bootstrap";
// import { AJOUT_COURS_NAVIGATION } from "../../../../Routes/NAVIGATION_PATH";
import { Link } from "react-router-dom";
import { isVisible } from "@testing-library/user-event/dist/utils";
import { collection, onSnapshot, query } from "firebase/firestore";
import { db } from '../../../../../Firebase';
import ListCourses from '../../../../../Component/ListCourses/ListCourses';
import { AJOUT_COURS_NAVIGATION } from '../../../../../Routes/NAVIGATION_PATH';
import { Date } from '../../../../../Services';
import PaginationContainer from '../../../../../Component/PaginationContainer/PaginationContainer';


export default function Approuve() {
	const [myCours, setMyCours] = useState([]);
	const [searchTerm, setSearchTerm] = useState("");
	const reftabCours = query(collection(db, "cours"));

	const getUsers = () => {
		onSnapshot(reftabCours, (item) => {
			const currentUserId = sessionStorage.getItem("user_id");
			const data = [];
			item.forEach((i) => {
				data.push({ ...i.data(), id: i.id });
			});

			setMyCours(
				data.filter(
					(elts) =>
						elts.admin_id === currentUserId || elts.created_by === currentUserId
				)
			);
		});
	};

	useEffect(() => {
		getUsers();
	}, []);

	const handelChange = (e) => { setSearchTerm(e.target.value); };


	const coursesApro = myCours.filter(
		(item) => item.isApproved === true && item.isArchived === false
	);
	
	const filteredData = coursesApro.filter((elt)=>{
		elt?.titre_cours?.toLowerCase().includes(searchTerm?.toLowerCase() ) ||
		elt?.description?.toLowerCase().includes(searchTerm?.toLowerCase() )  ||
		elt?.infoUser?.toLowerCase().includes(searchTerm?.toLowerCase() )
	})

	const myDatas = searchTerm === "" ? coursesApro : filteredData; 

	return (
		<>
			<div className="d-flex mb-2 justify-content-end ajouRecher">
			<input
				type="text"
				onChange={handelChange}
				value={searchTerm}
				className="form-control w-25"
				placeholder="Recherche cours"
			/>
				<Link to={AJOUT_COURS_NAVIGATION}>
					<Button variant="primary">Ajouter un cours</Button>
				</Link>{" "}

			</div>
			<Table striped bordered hover responsive>
				<thead>
					<tr className="py-5">
						<th>Cours</th>
						<th>STATUT</th>
						<th>ACTION</th>
					</tr>
				</thead>
				<tbody>
					<PaginationContainer data={myDatas.sort((a, b) => b.created_on.seconds - a.created_on.seconds)} ItemComponent={ListCourses}/>
				</tbody>
			</Table>
		</>
	)
}
